// export const SET_LANGUAGE = 'setLanguage';
// export const SET_ENV = 'setENV';
// export const SET_UI_MODULES = 'setUIModules';

// 用户信息 & 当前企业
export const SET_USER_INFO = 'setUserInfo';
export const SET_ENTERPRISE_ID = 'setEnterpriseId';
export const SET_ENTERPRISE_INFO_LIST = 'setEnterpriseInfoList';

// 用户所属所有组织列表 & 当前所选组织id
export const SET_ORG_LIST = 'setOrgList';
export const SET_ORGID = 'setOrgId';

// 企业下能看到所有产品列表 & 当前用户所属组织能看到的产品id列表
export const SET_ALL_PRODUCTS = 'setAllProducts';
export const SET_PRIV_PRODUCT_IDS = 'setPriviProductIDs';
export const SET_PRIV_PRODUCTS = 'setPriviProducts';

// License信息
export const SET_LICENSE_INFO = 'setLicenseInfo';

// 多语言
export const SET_LOCALE = 'setLanguage';

// 机器人操作记录用
export const SET_ROBOT_LIST = 'setRobotList';

export const SET_PRIVILEGE_LIST = 'setPrivilegeList';



// WEBPACK FOOTER //
// ./src/store/mutations_type.js